import { tokenStore } from '@/lib/storage/TokenStore';
import {
  selectAppAccessToken,
  selectFirebaseAccessToken,
  selectIsTokenVerified,
} from '@/lib/redux/app.selectors';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const useInitializeTokenSync = () => {
  const isTokenVerified = useSelector(selectIsTokenVerified);
  const firebaseAccessToken = useSelector(selectFirebaseAccessToken);
  const appAccessToken = useSelector(selectAppAccessToken);

  useEffect(() => {
    if (isTokenVerified) {
      tokenStore.setAppAccessToken(appAccessToken ?? '');
    }
  }, [appAccessToken, isTokenVerified]);

  useEffect(() => {
    if (isTokenVerified) {
      tokenStore.setFirebaseAccessToken(firebaseAccessToken ?? '');
    }
  }, [firebaseAccessToken, isTokenVerified]);
};

export default useInitializeTokenSync;
